module.exports = __webpack_public_path__ + "static/media/hero.ae2e0720.jpg";